"use strict";

Object.defineProperty(exports, "__esModule", {
        value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SolidRedWarning = function SolidRedWarning() {
        return _react2.default.createElement(
                "g",
                { id: "SolidRedWarning", stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
                _react2.default.createElement("image", { id: "key_over", x: "0", y: "0", width: "500", height: "500", xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAcCAYAAAB2+A+pAAAABGdBTUEAALGPC/xhBQAAA6pJREFUSA2tVk1IVFEUHh21tNTGGi1nGAJXUUHgSlAjEMNgAne5CWsp1CJoI4mL3BQoLQxaRBspwp0YhC2kIaxFLTQsJM1RR9MkR2bM+Z95fd/wzsx7b2ZsHD3w+c4999zznXPvPXc0mQqXIiwlCpL9LBTfbISKys6v6HsmVLznbHpSyOhvBkqXl5eb1tbWrtjt9jKMSwDxkQRhOrgI4RGEOu7z+QYVVaA/pQ3gHBPItxi47i2sgFUycOX4+HgzOGNCTH1sbKwVc1WqD30PpWpWUAocA2r9fv97DWlShe0D5uoAVk7fA1ct1ZYjWM3k5ORNI6mMXS7XbficBOh74KqZOS9PVX19vSMQCPwQIuM3GAwunoXQV11TcNWslpelArBOT0/3GcmM49nZ2Yf0VdfITccwfyGpVFvd2dl5LhqN/tES/X73VvG8GlEi29spM3x83d3dF7G2GuBlZAzGylu4gBnzQtW53e5nqeiq8q33vvLR2a4Ef63ppjwezwjXqGtztle2c2CGBC9I2cDAQIPD4bgFXSfmCp4AnMp5l9Jis9luDA8PX4DF+LCknXJoTIYtwdY4vbm5+UZXkjqYH3yUrDgeDmVMe71eF9aeUWNkbS9jxbpqR0dHm6xW6zUEyBBWXGQ2m4rLeJR6sVgsrRMTE+2wclJai7FTko1YKj7a0dHRB0/dAlnJLTZus8zx29LS8gAtyDvCLRdyTmUICejAQzs1NTV1N2MPNYaId0vZdS9qLJnqzMxMP2L9t71YafKxaGxsbAiFQquZodKW1dcvla/37ijxQCBtNGhoL29XV9d5xGV7MTY5dDvIgTwWtXNzc48NMTKG3/t7lU/XryqhjY2MOa1hZWXlBWLnbC+ptrqnp+dSLBbb0S7Opkf9PuXvz/lsUzpbIpGIDA0NXQb5CUAeFajpnuXZWhcWFp7oVh7CYGlp6Tli1wJs/uRTykopcrFKcC68YIcq4XCY/w7JK5Y6Yyps8krA1tbW1ry+vv4FW6T9sS+obsRIINZnp9PJrbYD/OVKPigkJZgN95/kNQB/Vy0AXy/pQ6h5SxyeEWAX2Aa2AC+wA4SAOAkp3IoEEAWCAB0o1LM+ecnZ3H8YKwZIrAB0xmZC5FK0xDSGAWbJhcxMqk2dC2z5CINL1YxDYsYW4lQz85IRvFiskIRMipALCHVfwuRJxEq57dwBgvaEVCJnzS/JJRGtHea8Jbmd8JYjlCRSdiFmRNGFTGujXoiQiCKEopv+AXRVUxNSVq88AAAAAElFTkSuQmCC" })
        );
};

exports.default = SolidRedWarning;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-icon/Icons/SolidRedWarning.js
// module id = 2988
// module chunks = 4